module.exports = __webpack_public_path__ + "static/img/check_green.f1e78ab.svg";